import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import BlackList from "./pages/BlackList";
import TrackList from "./pages/TrackList";

export default function ListOfTable({ user_type }) {
  const [tracklistChecked, setTracklistChecked] = useState(true);
  const [blacklistChecked, setBlacklistChecked] = useState(false);
  const handleTracklistChange = (e) => {
    setTracklistChecked(e.target.checked);
    setBlacklistChecked(false);
  };

  const handleBlacklistChange = (e) => {
    setBlacklistChecked(e.target.checked);
    setTracklistChecked(false);
  };
  let blacklist_data = "";
  if (user_type === true)
    blacklist_data = (
      <Form.Check
        type="checkbox"
        label="Blacklist"
        checked={blacklistChecked}
        onChange={handleBlacklistChange}
        style={{ margin: "0px 20px" }}
      />
    );
  return (
    <>
      <Form className="d-flex m-5">
        <Form.Check
          type="checkbox"
          label="Tracklist"
          checked={tracklistChecked}
          onChange={handleTracklistChange}
          style={{ margin: "0px 20px" }}
        />
        {blacklist_data}
      </Form>
      <Row>
        <Col sm={12} md={12} lg={12} xl={12}>
          {tracklistChecked && <TrackList />}
          {blacklistChecked && <BlackList />}
        </Col>
        {/* <Col sm={12} md={6} lg={6} xl={6}>
        </Col> */}
      </Row>
    </>
  );
}
